
const INITIAL_STATE = {}

const priceReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_Price":
                        return { ...state, listaprice: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                default:
                        return state
        }
}
export default priceReducer;
